<sm-title-bar [headerCustomTemplate]="addButton" [backLocation]="true" pageTitle="Available pack" *ngIf="!loader">
    <ng-template #addButton>
      <!-- Purchased -->
      <!-- <button mat-flat-button color="accent" style="color: #fff" (click)="onnewpackadd()">
        Add new pack
        <mat-icon class="material-icons-round" [inline]="true"
          >add_circle</mat-icon
        >
      </button> -->

      <div class="create_btn_sd">
        <button mat-icon-button color="primary" (click)="onnewpackadd()">
            <mat-icon>add</mat-icon> 
        </button> 
    </div>

    </ng-template>
  </sm-title-bar>
<div class="" *ngIf="!loader && entitySubscriptionHistoryData.length > 0">
  <div class="row">
    <div class="col-sm-4" *ngFor="let item of entitySubscriptionHistoryData">

    <div class="packs">
      <mat-card appearance="outlined">
        <div class="pack" >
            <div class="card_header">
                <h2>{{item.planName}}</h2>
                <p style="color: #000;">{{item.planDescription}}</p>

            </div>
            <div class="card_subheader">
                <p class="purchase-date">Purchased on {{item.creationDate | date}}</p>
                <p class="validity">{{item.validity}} days validity</p>

            </div>
            <button (click)="goToCreateBusiness(item)">Select Pack</button>
        </div>
      </mat-card>

    </div>
  
</div>
</div>
</div>